import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_GOOGLE_PAY_ENABLED = createFcmConfig('google_pay_enabled', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
